module.exports = __webpack_public_path__ + "static/media/video_upload_icon.2e8f1790.svg";